import { ensure, numberType, stringType, TType } from "types";

import { configDatabaseRecordType, IDatabaseRecord } from "@/core/api";

export enum ELegalDocumentType {
  PRIVACY_POLICY = "PRIVACY_POLICY",
  COOKIE_POLICY = "COOKIE_POLICY",
  USER_ACCESS_AGREEMENT = "USER_ACCESS_AGREEMENT",
}

export type TLegalDocumentType = keyof typeof ELegalDocumentType;

export interface ILegalDocument extends IDatabaseRecord {
  content: string;
  type: ELegalDocumentType;
  version: number;
}

const configLegalDocument: TType<ILegalDocument> = {
  ...configDatabaseRecordType,
  content: stringType(""),
  type: stringType(""),
  version: numberType(),
};

export const legalDocumentType = ensure(configLegalDocument);
